import React, { useEffect, useState } from "react";

import { Alert } from "react-bootstrap";

const ProtectedRoute = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkUserToken = () => {
    const userRaw = localStorage.getItem('user');
    const accessToken = localStorage.getItem('access_token');
    const isLoggedIn = sessionStorage.getItem('isLoggedIn');

    if (!accessToken || !userRaw || !isLoggedIn) {
      setIsLoggedIn(false);
      localStorage.setItem("destination", window.location.pathname);
      window.location.replace("/login-spid");
      return;
    }

    try {
      const userObj = JSON.parse(userRaw);
      const userData = JSON.parse(userObj.data); // Assicuriamoci di parsare correttamente i dati utente

      // Verifica che i dati utente contengano le informazioni necessarie
      if (!userObj.fiscal_code || !userData.identityProvider) {
        throw new Error("Dati utente non validi");
      }

      setIsLoggedIn(true);
    } catch (error) {
      console.error('Errore nella verifica dei dati utente:', error);
      setIsLoggedIn(false);
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace("/login-spid");
    }
  };

  useEffect(() => {
    checkUserToken();
  }, []);

  return (
    <React.Fragment>
      {
        isLoggedIn &&
        props.children
      }
    </React.Fragment>
  );
};
export default ProtectedRoute;
